/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useContext, useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AppContext } from "../contexts/AppContext";

const PermissionRoute = ({ children, checkRole }: { children: any, checkRole: string[] }) => {
    const { user, } = useContext(AppContext)
    const token = localStorage.getItem('token')
    const [loading, setLoading] = useState(true)
    let navigate = useNavigate()
    const history = useLocation()

    let authCheck = useCallback(async () => {
        try {
            if ((user?.role)?.toLowerCase() === 'admin' || checkRole.includes((user?.role)?.toLowerCase())) {
                setLoading(false);
            } else {
                toast.warning('You are not authorized!');
                navigate(`/`);
            }
        } catch (err) {
            setLoading(false)
            localStorage.removeItem('token');
            navigate("/login");
        }
    }, [token, history.pathname]);

    useEffect(() => {
        authCheck();
    }, [authCheck]);

    return loading ?
        <div className="preloader" >
            <div className="spinner" ></div >
        </div > : children
}

export default PermissionRoute;